export default class SecurityClassification {
  constructor() {
    this.arrCustomHoldingsAssetClasses = [];
    this.arrCustomTickerAssetClasses = [];
    this.arrRwAssetClasses = [];
    this.arrSecurityMasterList = [];
    this.arrCurrentHoldings = [];
  }
}
